import {
	browseMembers200Schema,
	browseMembersQueryParamsSchema,
	deleteMember200Schema,
	deleteMemberPathParamsSchema,
	generateMemberCSV200Schema,
	generateMemberCSVMutationRequestSchema,
	getMember200Schema,
	getMemberPathParamsSchema,
	listMembers200Schema,
	updateMember200Schema,
	updateMemberMutationRequestSchema,
	updateMemberPathParamsSchema,
} from "../schemas/memberCoreApi.schemas";
import type {
	BrowseMembers200Response,
	DeleteMember200Response,
	GenerateMemberCSV200Response,
	GetMember200Response,
	ListMembers200Response,
	UpdateMember200Response,
} from "../types/memberCoreApi.types";

/**
 * Shared endpoint contract configuration
 * This ensures both client and server use the same endpoint definitions
 */
export const memberCoreEndpointContract = {
	browseMembers: {
		path: "/members",
		method: "GET",
		querySchema: browseMembersQueryParamsSchema,
		responseSchema: browseMembers200Schema,
		responseType: {} as BrowseMembers200Response,
	},
	listMembers: {
		path: "/members/list",
		method: "GET",
		responseSchema: listMembers200Schema,
		responseType: {} as ListMembers200Response,
	},
	getMember: {
		path: "/members/:memberId",
		method: "GET",
		paramsSchema: getMemberPathParamsSchema,
		responseSchema: getMember200Schema,
		responseType: {} as GetMember200Response,
	},
	updateMember: {
		path: "/members/:memberId",
		method: "PUT",
		paramsSchema: updateMemberPathParamsSchema,
		bodySchema: updateMemberMutationRequestSchema,
		responseSchema: updateMember200Schema,
		responseType: {} as UpdateMember200Response,
	},
	deleteMember: {
		path: "/members/:memberId",
		method: "DELETE",
		paramsSchema: deleteMemberPathParamsSchema,
		responseSchema: deleteMember200Schema,
		responseType: {} as DeleteMember200Response,
	},
	generateMemberCSV: {
		path: "/members/csv",
		method: "POST",
		bodySchema: generateMemberCSVMutationRequestSchema,
		responseSchema: generateMemberCSV200Schema,
		responseType: {} as GenerateMemberCSV200Response,
	},
} as const;
